export const environment = {
  production: false,
  googleAnalyticsId: '' as string,
  /** Staging control-plane rejects `textSearchOptions` on cat/search (400 Bad Request); keep enabled elsewhere. */
  catalogueTextSearchOptionsEnabled: true,
  apiBaseUrl: 'http://localhost:3000/api',
  catalogueUiUrl: 'https://dev.mahaagx.iudx.io/',
  email: 'info@mahaagx.org.in',
  keycloak: {
    url: 'https://v2.dev.iudx.io/auth',
    realm: 'iudx-v2',
    clientId: 'angular-client',
  },

  // Api URLS
  basePathUrl: 'https://v2.dev.iudx.io/controlplane/',
  baseFilePathUrl: 'https://v2.dev.iudx.io/files-connect-api/',
  baseRsPathUrl: 'https://v2.dev.iudx.io/dataplane/',
  baseSandboxPathUrlCpu: 'https://v2.dev.sandbox.iudx.io/api/v1/',
  baseSandboxPathUrlGpu: 'https://v2.dev.sandbox.iudx.io/api/v1/',
  baseCommunityPathUrl: 'https://v2.dev.iudx.io/community',
  baseChallengePathUrl: 'https://tgdex-monorepo-dev.sirpi.co.in/challenge',
  dataReadinessS3Url:
    'https://s3-ap-south-1-iudx-v2-file-server-readiness-bucket.s3.ap-south-1.amazonaws.com/',
  auditingApiPath: 'iudx/v2/auditing/',
  authApiPath: 'iudx/v2/auth/',
  conversationApiPath: 'iudx/v2/requests/',
  catApiPath: 'iudx/v2/cat/',
  aclapdPath: 'iudx/acl/apd/v2/',
  leadershipApiPath: 'iudx/v2/leaderboard/',

  userManualUrl:
    'https://data-readiness-prod.s3.cyfuture.cloud/user-manual/User%20Manual%20-%20MahaAgX%20v1.0.pdf?domain=data-readiness-prod.s3.cyfuture.cloud',

  userApiPath: 'iudx/v2/auth/user/',
  userInteractionApiPath: 'iudx/v2/user',
  activitiesApiPath: 'iudx/v2/auditing/consumer/activity',
  rolesApiPath: 'iudx/v2/auth/roles',
  roleUpgradeApiPath: 'iudx/v2/auth/organization/user/provider_role/requests',

  ogcApiPath: 'https://v2.dev.iudx.io/geoserver-s3/',
  api_ogc_server_domain: 'https://v2.dev.iudx.io/geoserver-s3/', //Stac
  /** OGC process execution inputs (POST /processes/{id}/execution). */
  ogcS3BucketName: 's3-ap-south-1-iudx-v2-ogc-tiles',
  ogcS3Region: 'ap-south-1',
  ogcFileType: 'GeoPackage',
  ogcVersion: '1.0.0',
  ogcS3BucketIdentifier: 'default',
  ogcMapsResourceServerUrl: 'https://v2.dev.iudx.io/geoserver-s3/', //Feature
  ngsiLdApiPath: 'https://v2.dev.iudx.io/dataplane/',
  gatewayApiPath: 'https://v2.dev.iudx.io/dataplane/rsp/',

  /** Zoho (or other) contact form POST action URL. Submit goes here via form POST. */
  contactFormActionUrl: '' as string,
  /** API Explorer server base URL (overrides server from OpenAPI YAML). */
  apiExplorerServerUrl: 'https://v2.dev.iudx.io',

  // important links (use paths for footer routerLink; full URLs would duplicate domain in dev)
  importantLinks: {
    home: '/',
    provider: '/provider/home',
    consumer: '/consumer/home',
    canvas: '/canvas',
  },

  helpDeskUrl: 'https://v2.dev.iudx.io/help-desk',

  // API Documentation URLs (for footer links)
  apiDocsBaseUrl: 'https://api.mahaagx.org.in',
  controlPlaneApiDocsUrl: 'https://v2.dev.iudx.io/controlplane/apis',
  fileServerApiDocsUrl: 'https://v2.dev.iudx.io/files-connect-api/apis',
  resourceServerApiDocsUrl: 'https://v2.dev.iudx.io/dataplane/apis',
  ogcServerApiDocsUrl: 'https://api.mahaagx.org.in/auth',
  sandboxServerApiDocsUrl: 'https://api.mahaagx.org.in/auth',

  supersetDashboardUrl: 'https://v2.dev.iudx.io/dashboard',
  supersetGuestTokenEndpoint:
    'https://v2.dev.iudx.io/dashboard/middleware/middleware/guest_token',
  supersetDashboardId: '27',
  userActivitySupersetDashboardId: '26',
  computeRoleSupersetDashboardId: '30',
  organisationRequestsSupersetDashboardId: '28',
  datasetAccessRequestsSupersetDashboardId: '29',

  notebookListUiMock: false,
};
